import React from 'react';
import Dropdown from 'core/dropdown';
import noop from 'utils/noop';
import { parseDateUnit, UNIT_VALUES, UNIT_MODIFIER_VALUES } from 'utils/relativeDateTime';
import AmountInput from './AmountInput';
import UnitModifierDropdown from './UnitModifierDropdown';
import UnitDropdown from './UnitDropdown';
import { StyledCoreFormGroup } from './ToFromField.styled';

// type Props = {
//   /** Default unit when switching between past and future dates. */
//   defaultUnit: string,
//   /** If entire field is disabled. */
//   disabled: boolean,
//   /** The 'from' label. */
//   fromLabel: string,
//   /** Appended label for 'from' field. */
//   fromAppendLabel: string,
//   /** Hides to appended label for field. */
//   hideAppendLabel: boolean,
//   /** If field is 'to'. */
//   isToField: boolean,
//   /** Callback function when value is changed. */
//   onChange: (?string) => void,
//   /** Callback function when to/from value is changed. */
//   onChangeToFrom: () => {},
//   /** Show the to/from dropdown selector. */
//   showToFromDropdown: boolean,
//   /** Show the now option inthe unit modifer dropdown. */
//   showNow: boolean,
//   /** The 'to' label. */
//   toLabel: string,
//   /** Appended label for 'to' field. */
//   toAppendLabel: string,
//   /** Value of the field. */
//   value: string,
// };

export default class ToFromField extends React.Component {
  static defaultProps = {
    defaultUnit: UNIT_VALUES.day,
    disabled: false,
    fromLabel: 'From',
    fromAppendLabel: 'Ago',
    hideAppendLabel: false,
    isToField: true,
    label: '',
    onChange: noop,
    showNow: true,
    showToFromDropdown: false,
    toLabel: 'To',
    toAppendLabel: 'From Now',
  };

  /**
   * handleChangeValue
   * Callback function when the relative date changes.
   * @param { Object } e: The change event.
   * @param { String } value: The updated date.
   * @return { void }
   */
  handleChangeValue = (e, value) => {
    this.props.onChange(e, { value });
  };

  /**
   * handleChangeAmount
   * Callback function when amount value changes.
   * @param { Object } e: The change event.
   * @param { Object } amountInputProps: The props of the amount input containing the updated value.
   * @return { void }
   */
  handleChangeAmount = (e, { value }) => {
    const { defaultUnit, isToField, value: propValue } = this.props;
    const { unit, unitModifier } = parseDateUnit(propValue);
    const adjustedValue = isToField ? value : -1 * value;
    const unitModifierValue = unitModifier === UNIT_MODIFIER_VALUES.now ? '' : unitModifier;
    const newValue = `${isToField ? '+' : ''}${parseFloat(adjustedValue)}${unit || defaultUnit}${
      unitModifierValue || ''
    }`;
    this.handleChangeValue(e, newValue);
  };

  /**
   * handleChangeUnitModifier
   * Callback function when unit modifier value changes.
   * @param { Object } e: The change event.
   * @param { Object } modifierDropdownProps: The props of the unit modifier dropdown containing
   *                                          the updated value.
   * @return { void }
   */
  handleChangeUnitModifier = (e, { value }) => {
    const { amount, unit } = parseDateUnit(this.props.value);

    let newValue = '';
    if (value === UNIT_MODIFIER_VALUES.now) {
      newValue = `${value}`;
    } else if (value === UNIT_MODIFIER_VALUES.exactly) {
      newValue = `${amount}${unit}`;
    } else {
      newValue = `${amount}${unit || ''}${value}`;
    }
    this.handleChangeValue(e, newValue);
  };

  /**
   * handleChangeUnit
   * Callback function when unit value changes.
   * @param { Object } e: The change event.
   * @param { Object } unitDropdownProps: The props of the unit dropdown containing
   *                                      the updated value.
   * @return { void }
   */
  handleChangeUnit = (e, { value }) => {
    const { amount, unitModifier } = parseDateUnit(this.props.value);
    const unitModifierValue = unitModifier === UNIT_MODIFIER_VALUES.now ? '' : unitModifier;
    const newValue = `${amount}${value}${unitModifierValue || ''}`;
    this.handleChangeValue(e, newValue);
  };

  renderAppendDropdown = () => {
    const { fromAppendLabel, isToField, onChangeToFrom, toAppendLabel } = this.props;
    const options = [
      { text: toAppendLabel, value: true },
      { text: fromAppendLabel, value: false },
    ];
    return <Dropdown options={options} onChange={onChangeToFrom} value={isToField} />;
  };

  render() {
    const {
      disabled,
      fromLabel,
      fromAppendLabel,
      isToField,
      hideAppendLabel,
      showNow,
      showToFromDropdown,
      toLabel,
      toAppendLabel,
      value,
    } = this.props;
    const { amount, unitModifier, unit, isUnitModifierNow } = parseDateUnit(value);
    const unitMod = showToFromDropdown && !value ? UNIT_MODIFIER_VALUES.now : unitModifier;

    /** If value is a number, negate it since it's a relative value, else display the string. */
    const amountValue =
      typeof amount === 'number' && amount !== 0 && !isToField ? amount * -1 : amount;

    const appendLabel = isToField ? toAppendLabel : fromAppendLabel;
    const isPlural = amountValue < 1 || amountValue > 1;
    const disableOtherFields = isUnitModifierNow;

    return (
      <StyledCoreFormGroup>
        <UnitModifierDropdown
          disabled={disabled}
          label={isToField ? toLabel : fromLabel}
          onChange={this.handleChangeUnitModifier}
          showNow={showNow}
          value={unitMod}
        />
        <AmountInput
          disabled={disableOtherFields || disabled}
          onChange={this.handleChangeAmount}
          value={amountValue}
        />
        <UnitDropdown
          appendContent={showToFromDropdown ? this.renderAppendDropdown() : undefined}
          appendLabel={!hideAppendLabel && !disableOtherFields ? appendLabel : undefined}
          disabled={disableOtherFields || disabled}
          isPlural={isPlural}
          onChange={this.handleChangeUnit}
          value={unit}
        />
      </StyledCoreFormGroup>
    );
  }
}
